/**
 * ScribbleUnderline mark: M2.T10c §13.12.
 *
 * Used in lobby for field labels (e.g. "Game name:").
 * A wobbly hand-drawn underline SVG.
 */
export function ScribbleUnderline({ width = 80 }: { width?: number }) {
  const h = 6;
  const mid = h / 2;
  return (
    <svg
      class="mark-scribble-underline"
      viewBox={`0 0 ${width} ${h}`}
      width={width}
      height={h}
      aria-hidden="true"
    >
      <path
        d={`M 2 ${mid + 1} C 10 ${mid - 1} 20 ${mid + 2} 35 ${mid} C 50 ${mid - 1} 65 ${mid + 1} ${width - 2} ${mid + 0.5}`}
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
